import React from 'react'
import { Container, Row, Col } from 'reactstrap'

const About = () => (
  <div>
    <Container>
      <Row>
        <Col>
          <h1>About Page</h1>
          <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus quis varius purus. Proin sed dui tellus. In blandit facilisis faucibus. Fusce at rhoncus mi. </p>
        </Col>
      </Row>
    </Container>
  </div>
)

export default About



// WEBPACK FOOTER //
// ./src/containers/about/index.jsx